import { render, staticRenderFns } from "./AddChilrden.vue?vue&type=template&id=0e944372&scoped=true&"
import script from "./AddChilrden.vue?vue&type=script&lang=js&"
export * from "./AddChilrden.vue?vue&type=script&lang=js&"
import style0 from "./AddChilrden.vue?vue&type=style&index=0&id=0e944372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e944372",
  null
  
)

export default component.exports